// extracted by mini-css-extract-plugin
export default {"PromptSlider":"styles_PromptSlider__wlqPt"};